import { all } from 'redux-saga/effects';

import leaveStatusSagaWatcher from './leaveStatusSaga';

export default function* rootSaga(action) {
	yield all([leaveStatusSagaWatcher(action)]);
}
